
import React, { useState, useRef, useEffect } from 'react';
import { getStorage, removeStorage } from './storage';
import { useDarkMode, useScale } from './screens/common';
import {
  View,
  Text,
  Image,
  StyleSheet,
  SafeAreaView,
  TouchableOpacity,
  useWindowDimensions,
} from "react-native";
import { Feather, AntDesign, Ionicons } from '@expo/vector-icons';
import { createPortal } from 'react-dom';

// 메디로지스 로고(홈페이지 medilogis_logo.png) base64
const MEDILOGIS_LOGO = "data:image/png;base64,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";

import { createDrawerNavigator, DrawerContentScrollView, DrawerItemList } from '@react-navigation/drawer';
import { createStackNavigator, TransitionPresets } from "@react-navigation/stack";
import { NavigationContainer, useNavigationContainerRef } from '@react-navigation/native';
import linking from './navigation/LinkingConfiguration';
import { getHeaderTitle } from '@react-navigation/elements';

import Login from './screens/Login';
import Main from './screens/Main';
import Members from './screens/Members';
import MemberDetail from './screens/MemberDetail';
import Management from './screens/Management';
import Groups from './screens/Groups';
import GroupDetail from './screens/GroupDetail';
import Repeater from './screens/Repeater';
import RepeaterDetail from './screens/RepeaterDetail';
import RepeaterSetup from './screens/RepeaterSetup';
import Sensor from './screens/Sensor';
import SensorDetail from './screens/SensorDetail';
import Setting from './screens/Setting';
import PushAlram from './screens/PushAlram';
import Notice from './screens/Notice';
import SensorUse from './screens/SensorUse';
import SensorUseDetail from './screens/SensorUseDetail';
import ChangePW from './screens/ChangePW';
import CaregiverPushAlarm from './screens/CaregiverPushAlarm';
import SensorHistory from './screens/SensorHistory';
import SensorAnalysis from './screens/SensorAnalysis';
import Analysis from './screens/Analysis';
import AnalysisDetail from './screens/AnalysisDetail';
import SensorScreen from './screens/SensorScreen';
import SensorScreenDetail from './screens/SensorScreenDetail';
import CustomerInquiry from './screens/CustomerInquiry';
import Diaper from './screens/Diaper';
import DiaperViewer from './screens/DiaperViewer';
import Posture from './screens/Posture';
import DeletedSensorRecords from './screens/DeletedSensorRecords';
import DiaperEditRequests from './screens/DiaperEditRequests';
import FAQ from './screens/FAQ';
import ChatBot from './components/ChatBot';

const Drawer = createDrawerNavigator();
const Stack = createStackNavigator();

const MyStack = ({ session }: { session: any }) => {

  return (
    <Stack.Navigator initialRouteName={session?.id ? 'Main' : 'Login'}>
      <Stack.Screen
        name="Login"
        component={Login}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name="Main"
        component={DrawerNavigation}
        initialParams={session?.id ? session : undefined}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name="ChangePW"
        component={ChangePW}
        options={{
          headerTitle: '비밀번호 변경',
          headerTitleStyle: { fontSize: 20 },
          headerTintColor: '#fff',
          headerStyle: { backgroundColor: '#304156', height: 60 }
        }}
      />
      <Stack.Screen
        name="MemberDetail"
        component={MemberDetail}
        options={{
          headerTitle: '담당자 상세페이지',
          headerTitleStyle: { fontSize: 20 },
          headerTintColor: '#fff',
          headerStyle: { backgroundColor: '#304156', height: 60 },
          ...TransitionPresets.SlideFromRightIOS
        }}
      />
      <Stack.Screen
        name="GroupDetail"
        component={GroupDetail}
        options={{
          headerTitle: '그룹 상세페이지',
          headerTitleStyle: { fontSize: 20 },
          headerTintColor: '#fff',
          headerStyle: { backgroundColor: '#304156', height: 60 },
          ...TransitionPresets.SlideFromRightIOS
        }}
      />
      <Stack.Screen
        name="Setting"
        component={Setting}
        options={{
          headerTitle: '설정',
          headerTitleStyle: { fontSize: 20 },
          headerTintColor: '#fff',
          headerStyle: { backgroundColor: '#304156', height: 60 },
          ...TransitionPresets.SlideFromRightIOS
        }}
      />
      <Stack.Screen
        name="RepeaterDetail"
        component={RepeaterDetail}
        options={{
          headerTitle: '중계기 상세페이지',
          headerTitleStyle: { fontSize: 20 },
          headerTintColor: '#fff',
          headerStyle: { backgroundColor: '#304156', height: 60 },
          ...TransitionPresets.SlideFromRightIOS
        }}
      />
      <Stack.Screen
        name="SensorDetail"
        component={SensorDetail}
        options={{
          headerTitle: '센서 상세페이지',
          headerTitleStyle: { fontSize: 20 },
          headerTintColor: '#fff',
          headerStyle: { backgroundColor: '#304156', height: 60 },
          ...TransitionPresets.SlideFromRightIOS
        }}
      />
      <Stack.Screen
        name="SensorHistory"
        component={SensorHistory}
        options={{
          headerTitle: '센서 히스토리',
          headerTitleStyle: { fontSize: 20 },
          headerTintColor: '#fff',
          headerStyle: { backgroundColor: '#304156', height: 60 },
          ...TransitionPresets.SlideFromRightIOS
        }}
      />
      <Stack.Screen
        name="SensorAnalysis"
        component={SensorAnalysis}
        options={{
          headerTitle: '센서 분석',
          headerTitleStyle: { fontSize: 20 },
          headerTintColor: '#fff',
          headerStyle: { backgroundColor: '#304156', height: 60 },
          ...TransitionPresets.SlideFromRightIOS
        }}
      />
      <Stack.Screen
        name="SensorUseDetail"
        component={SensorUseDetail}
        options={{
          headerTitle: '센서 사용량 상세 페이지',
          headerTitleStyle: { fontSize: 20 },
          headerTintColor: '#fff',
          headerStyle: { backgroundColor: '#304156', height: 60 },
          ...TransitionPresets.SlideFromRightIOS
        }}
      />
      <Stack.Screen
        name="AnalysisDetail"
        component={AnalysisDetail}
        options={{
          headerTitle: '센서 분석 상세 페이지',
          headerTitleStyle: { fontSize: 20 },
          headerTintColor: '#fff',
          headerStyle: { backgroundColor: '#304156', height: 60 },
          ...TransitionPresets.SlideFromRightIOS
        }}
      />
      <Stack.Screen
        name="SensorScreenDetail"
        component={SensorScreenDetail}
        options={{
          headerTitle: '센서 화면 상세 페이지',
          headerTitleStyle: { fontSize: 20 },
          headerTintColor: '#fff',
          headerStyle: { backgroundColor: '#304156', height: 60 },
          ...TransitionPresets.SlideFromRightIOS
        }}
      />                      
    </Stack.Navigator>
  );
};

function CustomDrawerContent(props: any) {
  // console.log('props=', props);

  const onLogout = async () => {
    await removeStorage('Session');
    alert('로그아웃이 되었습니다.');
    props.navigation.reset({ index: 0, routes: [{ name: 'Login' }] });
  }

  return (
    <SafeAreaView style={{ flex: 1, backgroundColor: '#304156' }}>
      {/* 스크롤 영역이 브라우저 기본(밝은) 스크롤바를 쓰면 어두운 드로어에 흰 띠로 보인다.
          color-scheme: dark 로 네이티브 스크롤바를 어둡게 하고, 웹킷 쪽도 직접 칠한다. */}
      <style>{`
        .ml-drawer-scroll { scrollbar-width: thin; scrollbar-color: rgba(255,255,255,0.28) transparent; color-scheme: dark; }
        .ml-drawer-scroll::-webkit-scrollbar { width: 8px; background: transparent; }
        .ml-drawer-scroll::-webkit-scrollbar-track { background: transparent; }
        .ml-drawer-scroll::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.28); border-radius: 8px; }
      `}</style>
      <DrawerContentScrollView
        {...props}
        // @ts-ignore — RN Web 에서 DOM class 를 달아 스크롤바를 칠한다
        dataSet={{ class: 'ml-drawer-scroll' }}
        style={{ backgroundColor: '#304156' }}
        contentContainerStyle={{ paddingTop: 0, backgroundColor: '#304156' }}
      >
        {/* 기관 — 로고와 함께. 상단 헤더와 같은 브랜딩을 쓴다. */}
        <View style={styles.dwBrand}>
          <Image source={{ uri: MEDILOGIS_LOGO }} style={{ width: 26, height: 21, marginRight: 10 }} resizeMode="contain" />
          <Text style={styles.dwBrandText} numberOfLines={2}>{props?.hospital?.[0]?.NAME || '메디로지스'}</Text>
        </View>

        {/* 계정 */}
        <View style={styles.dwUser}>
          <View style={styles.dwAvatar}>
            <AntDesign name="user" size={20} color="#38BDF8" />
          </View>
          <View style={{ flex: 1, minWidth: 0 }}>
            <Text style={styles.dwUserId} numberOfLines={1}>{props?.id}</Text>
            <TouchableOpacity onPress={() => props.navigation.navigate('ChangePW')} hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}>
              <Text style={styles.dwUserLink}>비밀번호 변경</Text>
            </TouchableOpacity>
          </View>
        </View>

        <View style={styles.dwDivider} />
        <DrawerItemList {...props} />
      </DrawerContentScrollView>

      <View style={styles.dwFooter}>
        <TouchableOpacity style={styles.dwLogout} onPress={() => { onLogout() }} activeOpacity={0.7}>
          <Feather name="log-out" size={15} color="#CBD5E1" style={{ marginRight: 8 }} />
          <Text style={styles.dwLogoutText}>로그아웃</Text>
        </TouchableOpacity>
      </View>
    </SafeAreaView>
  );
};

const HeaderTitle = ({ navigation, route, options, server }: any) => {
  const { width: winW } = useWindowDimensions();
  const { dark, toggle: toggleDark } = useDarkMode();
  const { s } = useScale();
  const showVer = winW >= 700;
  // 상단 대메뉴(TopNav)와 같은 색·높이·비율을 쓴다. 로고는 아이콘만 —
  // "메디로지스" 글자까지 넣으면 폰에서 화면 제목이 밀린다.
  return (
    <View style={[styles.header, { height: s(60), paddingHorizontal: s(15) }]}>
      <View style={{ flexDirection: 'row', alignItems: 'center', flex: 1, minWidth: 0 }}>
        <TouchableOpacity onPress={() => { try { navigation.navigate('Main'); } catch (e) { } }}>
          <Image source={{ uri: MEDILOGIS_LOGO }} style={{ width: s(30), height: s(24), marginRight: s(12) }} resizeMode="contain" />
        </TouchableOpacity>
        <TouchableOpacity onPress={() => { navigation.openDrawer(); }}>
          <Feather name="menu" size={s(24)} color="#fff" style={{ marginLeft: 0, marginRight: s(16) }} />
        </TouchableOpacity>
        <Text style={[styles.headerTitle, { fontSize: s(18) }]} numberOfLines={1}>{getHeaderTitle(options, options?.drawerLabel)}</Text>
      </View>
      <View style={{ flexDirection: 'row', alignItems: 'center' }}>
        {showVer && (
          <>
            <Text style={{ marginLeft: s(20), color: '#fff', fontSize: s(13) }}>Web Ver. 1.0.0</Text>
            <Text style={{ marginHorizontal: s(10), color: '#fff', fontSize: s(13) }}> / </Text>
            <Text style={{ color: '#fff', fontSize: s(13) }}>Server Ver. {server}</Text>
          </>
        )}
        <TouchableOpacity onPress={toggleDark} style={{ paddingHorizontal: s(10), marginLeft: s(6) }}>
          <Ionicons name={dark ? 'sunny' : 'moon'} size={s(19)} color={dark ? '#FBBF24' : '#fff'} />
        </TouchableOpacity>
      </View>
    </View>
  )
};

// ─── 상단 대메뉴 (넓은 화면) ─────────────────────────────
const MENU_GROUPS = [
  { key: 'sensor',  label: '센서 이용',   items: [['센서 관리', 'Sensor'], ['센서 사용량 관리', 'SensorUse'], ['센서 분석', 'Analysis'], ['센서 화면', 'SensorScreen']] },
  { key: 'manage',  label: '관리 기능',   items: [['보호사 리스트', 'Members'], ['담당자 승인 관리', 'Management'], ['그룹 관리', 'Groups'], ['중계기 관리', 'Repeater'], ['중계기 설정', 'RepeaterSetup']] },
  { key: 'inquiry', label: '문의 기능',   items: [['공지사항', 'Notice'], ['자주 묻는 질문', 'FAQ'], ['1:1 문의하기', 'CustomerInquiry'], ['푸시 알림 전송', 'PushAlram'], ['보호사 SMS 알림 리스트', 'CaregiverPushAlarm']] },
  { key: 'diaper',  label: '기저귀 관리', items: [['기저귀 교체 기록', 'Diaper'], ['기저귀 기록 조회', 'DiaperViewer'], ['자세 기록', 'Posture'], ['기저귀 수정 요청 관리', 'DiaperEditRequests'], ['삭제된 센서 기록', 'DeletedSensorRecords']] },
];

// 역할별 접근 가능 화면 (드로어 등록 로직과 동일: isAdmin=0, isNormal=0|1, 그 외 전체공통)
const ADMIN_ONLY_SCREENS = ['Management', 'PushAlram', 'DiaperEditRequests', 'RepeaterSetup']; // role 0만
const NORMAL_SCREENS = ['Main', 'Members', 'Groups', 'Repeater', 'Sensor', 'Notice', 'CaregiverPushAlarm', 'SensorUse']; // role 0,1
// 뷰어(2)가 볼 수 있는 화면 — 알림 확인과 센서 분석.
// 목록에 없으면 못 본다(기본 차단). 아래 fallback 은 뷰어에게 적용되지 않는다.
// 첫 화면은 센서 화면으로 보낸다(아래 initialRouteName).
const VIEWER_SCREENS = ['SensorScreen', 'SensorScreenDetail', 'Analysis', 'AnalysisDetail'];

function canAccessScreen(name: string, role: any) {
  const r = Number(role);
  if (r === 2) return VIEWER_SCREENS.includes(name);
  if (ADMIN_ONLY_SCREENS.includes(name)) return r === 0;
  if (NORMAL_SCREENS.includes(name)) return r === 0 || r === 1;
  return true; // FAQ/CustomerInquiry/Analysis/Diaper/DiaperViewer 등 0·1 공통
}

function TopNav({ navigation, id, role }: any) {
  const { dark, toggle: toggleDark } = useDarkMode();
  const { s } = useScale();
  const menuGroups = MENU_GROUPS
    .map((g: any) => ({ ...g, items: g.items.filter(([, to]: any) => canAccessScreen(to, role)) }))
    .filter((g: any) => g.items.length > 0);
  const [open, setOpen] = useState<string | null>(null);
  const [pos, setPos] = useState<{ left: number; top: number }>({ left: 0, top: 58 });
  const btnRefs = useRef<any>({});
  const NAV = '#304156';
  const close = () => setOpen(null);
  const go = (to: string) => { close(); try { navigation.navigate(to); } catch (e) { } };
  const onLogout = async () => {
    close();
    await removeStorage('Session');
    alert('로그아웃이 되었습니다.');
    navigation.reset({ index: 0, routes: [{ name: 'Login' }] });
  };
  const toggle = (key: string) => {
    if (open === key) { close(); return; }
    const el = btnRefs.current[key];
    try { const r = el.getBoundingClientRect(); setPos({ left: r.left, top: r.bottom + 4 }); } catch (e) { }
    setOpen(key);
  };

  const itemCss: any = { padding: `${s(10)}px ${s(16)}px`, fontSize: s(14), color: '#1f2937', fontWeight: 500, cursor: 'pointer', whiteSpace: 'nowrap' };
  const panelCss: any = {
    position: 'fixed', top: pos.top, zIndex: 99999, background: '#fff', borderRadius: s(10),
    border: '1px solid #e5e7eb', padding: `${s(6)}px 0`, boxShadow: '0 6px 18px rgba(0,0,0,0.18)',
  };
  const curItems: any[] = (open && open !== 'user') ? (menuGroups.find((g: any) => g.key === open)?.items || []) : [];

  return (
    <View style={{ height: s(60), backgroundColor: NAV, flexDirection: 'row', alignItems: 'center', paddingHorizontal: s(20) } as any}>
      {/* 로고 */}
      <TouchableOpacity onPress={() => go('Main')} style={{ flexDirection: 'row', alignItems: 'center', marginRight: s(28) }}>
        <Image source={{ uri: MEDILOGIS_LOGO }} style={{ width: s(30), height: s(24), marginRight: s(8) }} resizeMode="contain" />
        <Text style={{ fontSize: s(18), fontWeight: '800', color: '#fff' }}>메디로지스</Text>
      </TouchableOpacity>
      {/* 대메뉴 */}
      <View style={{ flexDirection: 'row', alignItems: 'center' }}>
        {menuGroups.map((g: any) => {
          const active = open === g.key;
          return (
            <View key={g.key} ref={(el: any) => { btnRefs.current[g.key] = el; }}>
              <TouchableOpacity onPress={() => toggle(g.key)}
                style={{ flexDirection: 'row', alignItems: 'center', gap: s(4), paddingHorizontal: s(14), height: s(60) }}>
                <Text style={{ fontSize: s(15), fontWeight: '600', color: active ? '#38BDF8' : '#fff' }}>{g.label}</Text>
                <Ionicons name={active ? 'chevron-up' : 'chevron-down'} size={s(14)} color={active ? '#38BDF8' : '#cbd5e1'} />
              </TouchableOpacity>
            </View>
          );
        })}
      </View>
      <View style={{ flex: 1 }} />
      {/* 다크/라이트 토글 (전역, 상단 단일) */}
      <TouchableOpacity onPress={toggleDark} style={{ paddingHorizontal: s(10) }}>
        <Ionicons name={dark ? 'sunny' : 'moon'} size={s(19)} color={dark ? '#FBBF24' : '#fff'} />
      </TouchableOpacity>
      {/* 알림 */}
      <TouchableOpacity onPress={() => go('SensorScreen')} style={{ paddingHorizontal: s(10) }}>
        <Ionicons name="notifications-outline" size={s(20)} color="#fff" />
      </TouchableOpacity>
      {/* 관리자 */}
      <View ref={(el: any) => { btnRefs.current['user'] = el; }}>
        <TouchableOpacity onPress={() => toggle('user')}
          style={{ flexDirection: 'row', alignItems: 'center', gap: s(6), paddingHorizontal: s(10), height: s(60) }}>
          <Ionicons name="person-circle-outline" size={s(22)} color="#fff" />
          <Text style={{ fontSize: s(14), color: '#fff', fontWeight: '600' }}>{id || '관리자'}</Text>
          <Ionicons name={open === 'user' ? 'chevron-up' : 'chevron-down'} size={s(13)} color="#cbd5e1" />
        </TouchableOpacity>
      </View>

      {/* 드롭다운 (portal → body, 클리핑 회피) */}
      {open !== null && createPortal(
        <>
          <div onClick={close} style={{ position: 'fixed', inset: 0, zIndex: 99998 } as any} />
          <div style={{ ...panelCss, minWidth: open === 'user' ? s(160) : s(190), ...(open === 'user' ? { right: s(16) } : { left: pos.left }) }}>
            {open === 'user' ? (
              <>
                <div onClick={() => go('ChangePW')} style={itemCss}>비밀번호 변경</div>
                <div onClick={onLogout} style={{ ...itemCss, color: '#F87171', fontWeight: 600 }}>로그아웃</div>
              </>
            ) : curItems.map(([label, to]: any) => (
              <div key={to} onClick={() => go(to)} style={itemCss}>{label}</div>
            ))}
          </div>
        </>,
        document.body
      )}
    </View>
  );
}

// 반응형 헤더: 넓으면 상단 대메뉴, 좁으면 기존 햄버거+드로어
function AppHeader({ navigation, route, options, server, id, role }: any) {
  const { width } = useWindowDimensions();
  if (width >= 900) return <TopNav navigation={navigation} id={id} role={role} />;
  return <HeaderTitle navigation={navigation} route={route} options={options} server={server} />;
}

function DrawerNavigation({ route, navigation }: any) {
  const { id, hospital, server, role } = route.params || {};
  // ★ 기준을 AppHeader 의 TopNav 분기(900)와 **반드시 같게** 둔다.
  // 달라지면 "햄버거는 보이는데 드로어가 본문을 밀어내는" 구간이 생겨서,
  // 드로어를 여닫을 때 본문 폭이 250px 줄며 카드가 다시 줄바꿈되고 상단이 늘어난다.
  const { width: winWidth } = useWindowDimensions();
  const isNarrow = winWidth < 900;

  useEffect(() => {
    if (!id) {
      navigation.reset({ index: 0, routes: [{ name: 'Login' }] });
    }
  }, [id]);

  if (!id) return null;

  const isAdmin  = role === 0;
  const isViewer = role === 2;
  const isNormal = role === 0 || role === 1;
  
  return (
    <Drawer.Navigator
      defaultStatus="closed"
      useLegacyImplementation={true}
      screenOptions={{
        drawerType: isNarrow ? "front" : "slide",
        drawerStyle: {
          width: isNarrow ? Math.min(300, Math.round(winWidth * 0.82)) : 250,
          borderRightWidth: 1, borderColor: '#e8eade', backgroundColor: '#304156',
        },
        overlayColor: isNarrow ? 'rgba(0,0,0,0.45)' : 'transparent',
        // 활성 메뉴가 보이게 — 전엔 둘 다 흰색이고 활성 배경이 ''(빈 문자열)이라 구분이 없었다.
        drawerActiveTintColor: '#38BDF8',
        drawerInactiveTintColor: '#CBD5E1',
        drawerActiveBackgroundColor: 'rgba(56,189,248,0.14)',
        drawerItemStyle: { marginVertical: 1, marginHorizontal: 8, borderRadius: 8, paddingHorizontal: 2 },
        header: ({ navigation, route, options }) =>
          <AppHeader navigation={navigation} route={route} options={options} server={server} id={id} role={role} />
      }}
      initialRouteName={Number(role) === 2 ? "SensorScreen" : "Main"}
      drawerContent={(props) => <CustomDrawerContent {...props} id={id} hospital={hospital} />}
    >
      {/* 🔹 관리자 + 사용자 공통 */}
      {isNormal && (
        <>
          <Drawer.Screen name="Main" component={Main}
            options={{ drawerLabel: '메인', drawerLabelStyle: { fontSize: 17 } }}
          />
          <Drawer.Screen name="Members" component={Members}
            options={{ drawerLabel: '보호사 리스트', drawerLabelStyle: { fontSize: 17 } }}
          />
          {isAdmin && (
            <Drawer.Screen name="Management" component={Management}
              options={{ drawerLabel: '담당자 승인 관리', drawerLabelStyle: { fontSize: 17 } }}
            />
          )}
          <Drawer.Screen name="Groups" component={Groups}
            options={{ drawerLabel: '그룹 관리', drawerLabelStyle: { fontSize: 17 } }}
          />
          <Drawer.Screen name="Repeater" component={Repeater}
            options={{ drawerLabel: '중계기 관리', drawerLabelStyle: { fontSize: 17 } }}
          />
          {isAdmin && (
            <Drawer.Screen name="RepeaterSetup" component={RepeaterSetup}
              options={{ drawerLabel: '중계기 설정', drawerLabelStyle: { fontSize: 17 }, headerTitle: '중계기 설정' }}
            />
          )}
          <Drawer.Screen name="Sensor" component={Sensor}
            options={{ drawerLabel: '센서 관리', drawerLabelStyle: { fontSize: 17 } }}
          />
          {isAdmin && (
            <Drawer.Screen name="PushAlram" component={PushAlram}
              options={{ drawerLabel: '푸시 알림 전송', drawerLabelStyle: { fontSize: 17 } }}
            />
          )}
          <Drawer.Screen name="Notice" component={Notice}
            options={{ drawerLabel: '공지사항', drawerLabelStyle: { fontSize: 17 } }}
          />
          <Drawer.Screen name="CaregiverPushAlarm" component={CaregiverPushAlarm}
            options={{ drawerLabel: '보호사 SMS 알림 리스트', drawerLabelStyle: { fontSize: 17 } }}
          />
          <Drawer.Screen name="SensorUse" component={SensorUse}
            options={{ drawerLabel: '센서 사용량 관리', drawerLabelStyle: { fontSize: 17 } }}
          />
        </>
      )}

      {/* 🔹 모든 역할 공통 */}
      <Drawer.Screen name="FAQ" component={FAQ}
        options={{ drawerLabel: '자주 묻는 질문', drawerLabelStyle: { fontSize: 17 } }}
      />
      <Drawer.Screen name="CustomerInquiry" component={CustomerInquiry}
        initialParams={{ id, hospital }}
        options={{ drawerLabel: '1:1 문의하기', drawerLabelStyle: { fontSize: 17 } }}
      />

      {/* 🔹 Viewer 전용 */}
      <Drawer.Screen
        name="Analysis"
        component={Analysis}
        options={{ drawerLabel: '센서 분석', drawerLabelStyle: { fontSize: 17 } }}
      />
      <Drawer.Screen
        name="SensorScreen"
        component={SensorScreen}
        options={{ drawerLabel: '센서 화면', drawerLabelStyle: { fontSize: 17 } }}
      />
      <Drawer.Screen name="Diaper" component={Diaper}
        options={{ drawerLabel: '기저귀 교체 기록', drawerLabelStyle: { fontSize: 17 } }}
      />
      <Drawer.Screen name="DiaperViewer" component={DiaperViewer}
        options={{ drawerLabel: '기저귀 기록 조회', drawerLabelStyle: { fontSize: 17 } }}
      />
      <Drawer.Screen name="Posture" component={Posture}
        options={{ drawerLabel: '자세 기록', drawerLabelStyle: { fontSize: 17 } }}
      />
      <Drawer.Screen name="DeletedSensorRecords" component={DeletedSensorRecords}
        options={{ drawerLabel: '삭제된 센서 기록', drawerLabelStyle: { fontSize: 17 } }}
      />
      {isAdmin && (
        <Drawer.Screen name="DiaperEditRequests" component={DiaperEditRequests}
          options={{ drawerLabel: '기저귀 수정 요청 관리', drawerLabelStyle: { fontSize: 17 } }}
        />
      )}
    </Drawer.Navigator>
  );
}

export default function App() {
  const navRef = useNavigationContainerRef();
  const [routeName, setRouteName] = useState<string | undefined>(undefined);
  const [authLoading, setAuthLoading] = useState(true);
  const [session, setSession] = useState<any>(null);

  useEffect(() => {
    (async () => {
      const s = await getStorage('Session');
      if (s?.id) setSession(s);
      setAuthLoading(false);
    })();
  }, []);

  if (authLoading) {
    return <View style={{ flex: 1, backgroundColor: '#304156' }} />;
  }

  return (
    <View style={{ flex: 1 }}>
      <NavigationContainer
        ref={navRef}
        linking={linking}
        onReady={() => setRouteName(navRef.getCurrentRoute()?.name)}
        onStateChange={() => setRouteName(navRef.getCurrentRoute()?.name)}
      >
        <MyStack session={session} />
      </NavigationContainer>
      {routeName && routeName !== 'Login' && <ChatBot navRef={navRef} />}
    </View>
  );
};

const styles = StyleSheet.create({
  header: {
    paddingHorizontal: 15,
    height: 60,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#304156',
  },
  headerTitle: {
    fontSize: 20,
    color: "#fff",
  },
  dwBrand: {
    flexDirection: 'row', alignItems: 'center',
    paddingHorizontal: 16, paddingTop: 18, paddingBottom: 14,
  },
  dwBrandText: { flex: 1, fontSize: 17, fontWeight: '700', color: '#fff', lineHeight: 22 },
  dwUser: {
    flexDirection: 'row', alignItems: 'center',
    marginHorizontal: 12, marginBottom: 14,
    paddingHorizontal: 12, paddingVertical: 12,
    borderRadius: 10, backgroundColor: '#202D3C',
  },
  dwAvatar: {
    width: 36, height: 36, borderRadius: 18, marginRight: 12,
    justifyContent: 'center', alignItems: 'center',
    backgroundColor: 'rgba(56,189,248,0.16)',
  },
  dwUserId: { fontSize: 15, fontWeight: '700', color: '#fff' },
  dwUserLink: { fontSize: 12, color: '#38BDF8', marginTop: 3, fontWeight: '600' },
  dwDivider: { height: 1, backgroundColor: 'rgba(255,255,255,0.10)', marginHorizontal: 12, marginBottom: 8 },
  dwFooter: { borderTopWidth: 1, borderTopColor: 'rgba(255,255,255,0.10)', padding: 12 },
  dwLogout: {
    flexDirection: 'row', alignItems: 'center', justifyContent: 'center',
    paddingVertical: 11, borderRadius: 8, backgroundColor: 'rgba(255,255,255,0.06)',
  },
  dwLogoutText: { color: '#CBD5E1', fontWeight: '600', fontSize: 14 },
  menutitle: {
    width: '100%',
    borderRadius: 3,
    paddingVertical: 13,
    fontSize: 15,
    color: '#666',
    fontWeight: '500',
    paddingLeft: 8,
  },
  menuContainer: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center'
  },
  menuItemsCard: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 10,
  },
  circleContainer: {
    width: 50,
    height: 50,
    borderRadius: 25,
    padding: 10,
  },


});


